<template>
    <div class="footer">
        <el-row :gutter="20">
            <el-col :span="6">
                <div class="footer-list">
                    <h3><router-link to="/company">Company</router-link></h3>
                    <span @click="goTopView('aboutUs')">About Us</span>
                    <span @click="goTopView('solutionMatrix')">Solution Matrix</span>
                    <span @click="goTopView('contactUs')">Contact</span>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="footer-list">
                    <h3 @click="goProductsNav">Products</h3>
                    <router-link to="/carConfigurator">Car Configurator</router-link>
                    <router-link to="/mobileSmartCar">Mobile Smart Car Sales Assistance</router-link>
                    <router-link to="/realTime3d">Realtime 3D Asset Visualization</router-link>
                    <router-link to="/autoDrive">Auto Drive Content Platform</router-link>
                    <router-link to="/VR&AR">VR & AR Innovation</router-link>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="footer-list">
                    <h3><router-link to="/projects">Projects</router-link></h3>
                    <router-link to="/projects">All Projects</router-link>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="footer-list">
                    <h3 @click="goBrandNav">CUSTOMERS & PARTNERS</h3>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <div class="link-list">
                    <a href="https://space.bilibili.com/627621237" target="_blank"><img src="../assets/common/link-1.png" /></a>
                    <!-- <a href="#"><img src="../assets/common/link-2.png" /></a> -->
                    <a href="https://www.youtube.com/channel/UCcvlziBNfAEZrU2gypywvzw?view_as=subscriber" target="_blank"><img src="../assets/common/link-3.png" /></a>
                    <router-link :to="{path:'/company#contactUs'}"><img src="../assets/common/link-4.png" /></router-link>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <div class="copyright">
                    <span>Copyright © 2020 上海炫伍科技股份有限公司</span>
                    <a href="http://beian.miit.gov.cn/" target="_blank">沪ICP备10019825号</a>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>

export default {
  data () {
    return {}
  },
  methods: {
    goProductsNav () {
      this.$nextTick(() => {
        this.$router.push('/?#products')
      })
    },
    goBrandNav () {
      this.$nextTick(() => {
        this.$router.push('/?#brandExperience')
      })
    },
    goTopView(selector){
        this.$nextTick(() => {
            this.$router.push('/company?#'+selector)
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../style/common';
.footer
    padding 7rem 10rem 1rem 10rem
    background #000
.footer-list
    text-align center
    h3
        font-size 1.8rem
        color #fff
        font-weight 500
        text-transform uppercase
        margin-bottom 2rem
        cursor pointer
        a
            font-size 1.8rem
            color #fff
    a
        font-size 1.2rem
        color #B4B4B4
        margin-bottom 1rem
        text-decoration none
        display block
    span
        font-size 1.2rem
        color #B4B4B4
        margin-bottom 1rem
        display block
        cursor pointer
.link-list
    text-align center
    padding 4rem 0 1rem 0
    a
        outline none
        img
            width 3.5rem
            margin-right 2rem
.copyright
    text-align center
    padding-bottom 1rem
    span
        font-size 1rem
        color #5F5F5F
    a
        font-size 1rem
        color #5F5F5F
        text-decoration none
        margin-left 3rem
</style>
